export const errorCodes = {
  NOT_ENOUGH_CLUBCOIN: 2001,
  TUTORIAL_NOT_COMPLETED: 2002,
  ALREADY_SUBSCRIBED: 2003,
  TARGET_PLAN_NOT_FOUND: 2004,
  CANNOT_DOWNGRADE: 2005,
} as const;
